<form class="ui form" #form="ngForm">
    <ng-container *ngIf="eligibleProducts?.length; else noEligibleProducts">
        <div *ngFor="let product of eligibleProducts" class="ui segment">
            <ui-button
                *ngIf="!isProductSelected(product)"
                (click)="selectProduct(product)"
                style="float: right"
                type="outline"
            >
                {{ 'settings.billing.subscribeFormSelectButton' | appTranslate }}
            </ui-button>
            <ui-button
                *ngIf="isProductSelected(product)"
                (click)="unselectProduct(product)"
                style="float: right"
                type="primary"
                >{{ 'settings.billing.subscribeFormUnselectButton' | appTranslate }}</ui-button
            >
            <app-segment-header [title]="product.name"></app-segment-header>
            <p>{{ product.description }}</p>
            <p *ngIf="product.perEmployee">
                {{
                    'settings.billing.productPerEmployeePrice'
                        | translate
                            : {
                                  amount: product.defaultPlan?.amount,
                                  interval: product.defaultPlan?.interval,
                                  unit: product.unitLabel,
                              }
                }}
            </p>
            <p *ngIf="!product.perEmployee">
                {{
                    'settings.billing.productPerIntervalPrice'
                        | translate: { amount: product.defaultPlan?.amount, interval: product.defaultPlan?.interval }
                }}
            </p>
        </div>
    </ng-container>
    <ng-template #noEligibleProducts>
        <p>{{ 'settings.billing.noEligibleProductsMessage' | appTranslate }}</p>
        <input type="hidden" name="preventSave" required />
    </ng-template>

    <input type="hidden" [ngModel]="selectedModuleCount" name="selectedModuleCount" required />
</form>
